var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaterialSymbolsStackedInbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 17C6.45 17 5.97933 16.8043 5.588 16.413C5.19667 16.0217 5.00067 15.5507 5 15V5C5 4.45 5.196 3.97933 5.588 3.588C5.98 3.19667 6.45067 3.00067 7 3H21C21.55 3 22.021 3.196 22.413 3.588C22.805 3.98 23.0007 4.45067 23 5V15C23 15.55 22.8043 16.021 22.413 16.413C22.0217 16.805 21.5507 17.0007 21 17H7ZM14 12C14.55 12 15.021 11.8043 15.413 11.413C15.805 11.0217 16.0007 10.5507 16 10H21V5H7V10H12C12 10.55 12.196 11.021 12.588 11.413C12.98 11.805 13.4507 12.0007 14 12ZM19 21H3C2.45 21 1.97933 20.8043 1.588 20.413C1.19667 20.0217 1.00067 19.5507 1 19V7H3V19H19V21Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialSymbolsStackedInbox);
export default __webpack_public_path__ + "static/media/material-symbols_stacked-inbox.ee386f806b8a3f612662af50c3cb93cb.svg";
export { ForwardRef as ReactComponent };